if (!customElements.get('dropdown-country')) {
  class DropdownCountry extends HTMLElement {
    selectors = {
      button: '[dropdown-country="button"]',
      menu: '[dropdown-country="menu"]',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector(this.selectors.button);
      this.menu = this.querySelector(this.selectors.menu);

      if (!this.button || !this.menu) return;

      this.button.addEventListener('click', this.onToggle.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this));
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onToggle);
      window.removeEventListener('resize', this.updatePlacement.bind(this));
      window.removeEventListener(
        'scroll',
        this.updatePlacement.bind(this),
        true,
      );
      document.removeEventListener('click', this.onDocumentClick.bind(this));
    }

    onToggle() {
      this.menu.classList.toggle('is-visible');
      this.classList.toggle('open');

      const isOpen = this.classList.contains('open');

      if (isOpen) {
        this.updatePlacement();
      }
    }

    // Calculate distances to viewport edges and toggle placement classes
    updatePlacement() {
      if (!this.menu || !this.classList.contains('open')) return;
      this.classList.remove('overflow-bottom', 'overflow-top');

      requestAnimationFrame(() => {
        const rect = this.menu.getBoundingClientRect();
        const vpHeight =
          (window.innerHeight || document.documentElement.clientHeight) - 25;

        const overflowBottom = rect.bottom > vpHeight;
        const overflowTop = rect.top < 25;

        this.classList.toggle('overflow-bottom', overflowBottom);
        this.classList.toggle('overflow-top', overflowTop);
      });
    }

    onDocumentClick(event) {
      if (!this.classList.contains('open')) return;

      if (this.contains(event.target)) return;

      this.classList.remove('open');
      this.menu.classList.remove('is-visible');
    }
  }

  customElements.define('dropdown-country', DropdownCountry);
}
